<script>
  import CreateView from '../base/CreateView.vue'
  import FormInput from '../form/form-input.vue'
  import FormDataurl from '../form/form-dataurl.vue'

  export default {
    components: {
      CreateView,
      FormInput,
      FormDataurl,
    },
    methods: {
      updateFilename (filename) {
        this.$store.dispatch('companyasset/create/updateItem', { filename })
      },
      resetted () {
        this.$store.dispatch('companyasset/create/updateItem', {company: this.$route.params['company']})
      }
    }
  }
</script>
<template>
  <create-view store="companyasset" update-route="CompanyAssetUpdate" v-slot:default="slotProps" @reset="resetted">
    <form-input :store="slotProps.store" prop-name="filename" class="col-12"></form-input>
    <form-dataurl :store="slotProps.store" prop-name="content" @fileLoaded="updateFilename" class="col-12"></form-dataurl>
  </create-view>
</template>

